import React, { useContext, useState, useRef, useEffect } from "react";
import { CartContext } from "../context/CartContext";
import { SearchContext } from "../context/SearchContext";
import { NavLink, useNavigate } from "react-router-dom";
import { FaShoppingCart, FaHeart } from "react-icons/fa";
import "./Navbar.css";
import logo from "../assets/Logo6.png";

const Navbar = () => {
  const { cart, wishlist } = useContext(CartContext);
  const { search, setSearch } = useContext(SearchContext);

  const navigate = useNavigate();

  const [showCart, setShowCart] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const cartRef = useRef();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Close cart when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (cartRef.current && !cartRef.current.contains(e.target)) {
        setShowCart(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="navbar">

      {/* LOGO */}
      <div className="logo-wrapper" onClick={() => handleNavigate("/")}>
        <img src={logo} alt="logo" className="logo-img" />
        <span className="logo1">KHUSHI BAGS</span>
      </div>

      {/* HAMBURGER */}
      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* MENU */}
      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>  
        <NavLink to="/ourjourney" onClick={() => setMenuOpen(false)}>Our Journey</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
      </div>

      {/* RIGHT SIDE */}
      <div className="nav-right">

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search bags..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search"
        />

        {/* ❤️ WISHLIST */}
        <div className="icon-badge" onClick={() => navigate("/wishlist")}>
          <FaHeart />
          {wishlist.length > 0 && (
           <span className="badge">
  {wishlist.length > 99 ? "99+" : wishlist.length}
</span>
          )}
        </div>

        {/* 🛒 CART */}
        <div
          className="icon-badge"
          ref={cartRef}
          onClick={() => setShowCart(!showCart)}
        >
          <FaShoppingCart />
          {cart.length > 0 && (
            <span className="badge">{cart.length}</span>
          )}

          {/* CART DROPDOWN */}
          {showCart && (
            <div className="cart-dropdown">
              {cart.length === 0 ? (
                <p style={{ padding: "10px" }}>Cart is empty</p>
              ) : (
                <>
                  <div className="cart-items">
                    {cart.map((item) => (
                      <div key={item.id} className="cart-item">
                        <img
                          src={item.image || item.images?.[0]}
                          alt={item.name}
                        />
                        <div>
                          <p>{item.name}</p>
                          <span>₹{item.price} x {item.qty}</span>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="cart-footer">
                    <button onClick={() => navigate("/cart")}>
                      View Cart
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)}></div>
      )}
    </div>
  );
};

export default Navbar;